<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Series Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Author’s Preface</a></div>
<div class="SOM_pre"><a href="#/pre4">Abbreviations</a></div>
<div class="SOM_pre"><a href="#/pre5">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev3">1</span> The Creation of Adam</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev3">2</span> Fall and Restoration</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev3">3</span> Israel’s Creation and Fall</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev3">4</span> Israel’s Restoration in the “Latter Days”</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev3">5</span> Jesus as King</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev3">6</span> Jesus as Priest</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev3">7</span> Jesus as Prophet</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev3">8</span> The Church as Kings</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev3">9</span> The Church as Priests</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev3">10</span> The Church as Prophets</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="mev3">11</span> The Church in the New Creation</span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><span class="mev3">12</span> Concluding Practical Reflections</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Author Index</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Praise for <i>From Adam and Israel to the Church</i></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?081a2747